import { getFunctions, httpsCallable, Functions } from 'firebase/functions';
import { app } from '@/lib/firebase';
import type { AIMessage } from './service';

export type AIProxyProviderId = 'openai' | 'deepseek' | 'gemini';

export type AIChatRequest = {
  providerId: AIProxyProviderId;
  messages: Pick<AIMessage, 'role' | 'content'>[];
  model?: string;
  temperature?: number;
  maxTokens?: number;
};

export type AIChatResult = {
  content: string;
  tokens: { prompt: number; completion: number; total: number };
  model: string;
  provider: AIProxyProviderId;
};

export type AIImageRequest = {
  prompt: string;
  model?: string;
  size?: string;
  n?: number;
};

export type AIImageResult = {
  data: Array<{ url?: string; b64_json?: string; revised_prompt?: string }>;
  model: string;
  provider: 'openai';
};

let functionsInstance: Functions | null = null;

function getFunctionsInstance(): Functions {
  if (!functionsInstance) {
    // Keep region consistent with deployed functions.
    functionsInstance = getFunctions(app, 'europe-west1');
  }
  return functionsInstance;
}

export async function aiChat(request: AIChatRequest): Promise<AIChatResult> {
  const fn = httpsCallable(getFunctionsInstance(), 'aiChat');
  const result = await fn(request);
  return result.data as AIChatResult;
}

export async function aiImageGenerate(request: AIImageRequest): Promise<AIImageResult> {
  const fn = httpsCallable(getFunctionsInstance(), 'aiImageGenerate');
  const result = await fn(request);
  return result.data as AIImageResult;
}
